// TODO review and refactor

// export const inspectionStringListBuilder = (arr: (string | null)[]): string => {
//   const validStrings = uniq(arr.filter((str) => str && str !== '')) as string[];
//   return validStrings.map((str) => {
//     let output = str;
//     if (!['re_inspection', 're_visit', 'pre_inspection'].includes(str)) {
//       output = str.replace(/_inspection$/g, '');
//     }
//     return getFormattedString(output);
//   }).join(', ');
// };

// const getInspectionTypeValues = (
//   inspections: InspectionType,
//   inspectionIds: IdRef[],
// ): string[] => (
//   inspectionIds.reduce((acc, id) => {
//     if (inspections?.[id]?.inspectionType) acc.push(inspections[id].inspectionType);
//     return acc;
//   }, [] as string[])
// );

// export const getInspectionTypes = (
//   inspections: InspectionType,
//   inspectionIds: IdRef[],
// ): string => {
//   const inspectionTypes = getInspectionTypeValues(inspections, inspectionIds);
//   return inspectionTypes.length > 0 ? stringListBuilder(inspectionTypes) : '-';
// };

// export const getFormattedInspectionTypes = (
//   inspections: InspectionType,
//   inspectionIds: IdRef[],
// ): string => {
//   const inspectionTypes = getInspectionTypeValues(inspections, inspectionIds);
//   return inspectionTypes.length > 0 ? inspectionStringListBuilder(inspectionTypes) : '-';
// };

// export const getInspectionTemplateIds = (
//   inspections: InspectionType,
//   inspectionIds: IdRef[],
// ): string[] => uniq(inspectionIds.reduce((acc, id) => {
//   if (inspections?.[id]?.templateReportId) {
//     acc.push(inspections[id].templateReportId as string);
//   }
//   return acc;
// }, [] as string[]));

// export const getInspectionTemplates = (
//   inspections: InspectionType,
//   inspectionIds: IdRef[],
//   templates: TemplatesInterface,
// ): string => {
//   const templateReportIds = getInspectionTemplateIds(inspections, inspectionIds);
//
//   const templateNames = templateReportIds
//     .filter((templateId) => templates?.[templateId]?.report?.name)
//     .map((templateId) => templates[templateId].report.name);
//
//   return templateNames.length > 0 ? templateNames.join(', ') : '-';
// };

// export const isGeotaggingRequired = (
//   inspections: InspectionType,
//   inspectionIds: IdRef[],
// ) => inspectionIds.some((id) => inspections?.[id]?.geotaggingRequired);

// type ComplianceCheckOptions = {
//   templateIds: string[],
//   templates: TemplatesInterface;
// };

// export const isDenverRentalComplianceInspection = ({
//   templateIds,
//   templates,
// }: ComplianceCheckOptions) => {
//   const denverInspections = templateIds.filter((templateId) => (
//     (templates?.[templateId]?.report?.name || '').toLocaleLowerCase().includes('denver rental compliance')
//   ));
//   return denverInspections.length > 0;
// };

// export const isReInspection = (id: IdRef, inspections: InspectionType) => {
//   if (inspections[id]?.inspectionType) {
//     const type = inspections[id]?.inspectionType;
//     const match = type.match(/^re.?inspection$/gi) || [];
//     return match.length > 0;
//   }
//   return false;
// };

// export const getReInspection = (job: JobType, inspections: InspectionType) => {
//   const reInspectionId = job.inspectionIds.find((id) => isReInspection(id, inspections));
//   return reInspectionId ? inspections[reInspectionId] : null;
// };

export enum InspectionTypeWithScopeNumber {
    DRAW_INSPECTION = 'draw_inspection',
    SOW_INSPECTION = 'sow_inspection',
    LAND_DEVELOPMENT_INSPECTION = 'land_development_inspection',
}
const inspectionTypeWithScopeNumberSet = new Set<string>(Object.values(InspectionTypeWithScopeNumber));

export const isInspectionTypeWithScopeNumber = (type?: string): boolean => {
    return type ? inspectionTypeWithScopeNumberSet.has(type) : false;
};